<template>
    <div id="print">
        <v-app>
            <link rel="stylesheet"
                  type="text/css"
                  href="/assets/css/templatecss.css" />
            <link rel="stylesheet" type="text/css" href="/assets/css/vuetify.css" />
            <v-content style="background-color: white">

                <div ref="content1" id="content_1" class="pageA4" v-if="projeto.cliente">
                    <div class="container"
                         style="padding-left: 50px; padding-bottom: 0px">

                        <figure style="margin-top:20mm">
                            <img :src="aldoSolarLogo" style="width: 100%" />
                        </figure>

                        <div class="row">
                            <div style="margin-left:10mm; margin-top:10mm">
                                <h4 class="main-title">PROPOSTA COMERCIAL DE ENERGIA SOLAR</h4>
                            </div>
                        </div>

                        <div style="margin-top:40px">
                            <div class="row">
                                <p>Elaborada para {{projeto.cliente.nome}}</p>
                            </div>
                            <div class="row">
                                <p>{{projeto.cliente.documento}}</p>
                            </div>
                            <div class="row">
                                <p>{{projeto.cliente.endereco}}</p>
                            </div>
                            <div class="row">
                                <p>{{projeto.cliente.cidade}}-{{projeto.cliente.estado}}</p>
                            </div>
                            <div class="row">
                                <p>{{projeto.cliente.telefone1}}</p>
                            </div>
                            <div class="row">
                                <p>{{projeto.cliente.email}}</p>
                            </div>
                        </div>

                        <div style="margin-top:80mm">
                            <div class="row" style="display: flex; align-items: center; justify-content: center;">
                                <div class="col-xs-6" style=" display: flex; align-items: center; justify-content: center;">
                                    <img :src="projeto.contatoRevenda.imagemBase64"
                                         v-if="projeto.contatoRevenda.imagemBase64"
                                         style="max-height: 64px; margin-top: 2mm" />
                                    <img :src="projeto.imagemUrl"
                                         v-if="projeto.imagemUrl"
                                         style="max-height: 64px; margin-top: 2mm" />
                                </div>
                            </div>

                            <div class="row" style="display: flex; align-items: center; justify-content: center;">
                                <div class="col-xs-6" style=" display: flex; align-items: center; justify-content: center;">
                                    <p class="label-t2 bold">{{ projeto.contatoRevenda.empresa }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-------------------------------------------------------------------------------------------------------------------------------------------------->
                <div ref="content2" id="content_2" class="pagebreak pageA4" v-if="projeto.contatoRevenda && projeto.contatoRevenda.empresa">
                    <div class="container"
                         style="padding-left: 50px; padding-bottom: 0px">
                        <div class="row" style="margin-top:20mm">
                            <h1>{{projeto.contatoRevenda.empresa}}</h1>
                        </div>

                        <div class="row" style="margin-top:30mm">
                            <h4>{{projeto.contatoRevenda.sobre}}</h4>
                        </div>

                        <div style="margin-top:50mm">
                            <div class="row">
                                <div class="col-xs-6">
                                    <img :src="projeto.contatoRevenda.imagemBase64"
                                         v-if="projeto.contatoRevenda.imagemBase64"
                                         style="max-height: 64px; margin-top: 2mm" />
                                    <img :src="projeto.imagemUrl"
                                         v-if="projeto.imagemUrl"
                                         style="max-height: 64px; margin-top: 2mm" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xs-6">
                                    <p class="label-t2 bold">{{ projeto.contatoRevenda.empresa }}</p>
                                </div>
                            </div>
                        </div>

                        <div style="margin-top:10mm">
                            <div class="row">
                                <p>{{projeto.contatoRevenda.empresa}}</p>
                            </div>
                            <div class="row">
                                <p>{{projeto.contatoRevenda.endereco}}</p>
                            </div>
                            <div class="row">
                                <p>{{projeto.contatoRevenda.telefone}}</p>
                            </div>
                            <div class="row">
                                <p>{{projeto.contatoRevenda.email}}</p>
                            </div>
                            <div class="row">
                                <p>{{projeto.contatoRevenda.site}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-------------------------------------------------------------------------------------------------------------------------------------------------->
                <div ref="content3" id="content_3" class="pagebreak pageA4" v-if="selectedProduct">
                    <div class="container">
                        <div class="row">
                            <p class="header-title">
                                DETALHAMENTO DO GERADOR DE ENERGIA SOLAR
                            </p>
                        </div>

                        <div class="row" style="display: flex">
                            <div class="col-xs-3" style="display: flex">
                                <div style="
                    position: relative;
                    padding: 10px;
                    border: 1px solid black;
                    margin-right: 15px;
                  ">
                                    <img style="
                      position: relative;
                      top: 50%;
                      transform: translateY(-50%);
                    "
                                         :src="getImagemProduto" />
                                </div>
                            </div>
                            <div class="col-xs-9" v-if="selectedProduct">
                                <p class="px-0 label-t2 font-italic">
                                    Código: {{ selectedProduct.PRD_CODIGO }}
                                </p>
                                <p class="pt-3 label-t2">{{ selectedProduct.Titulo }}</p>

                                <!--<p class="pt-5 label-t3">
                                    Valor da cotação à vista:
                                    <span class="label-t4 bold color-red">
                                        R${{ projeto.valorEUP }}
                                    </span>
                                </p>-->
                            </div>
                        </div>

                        <div class="row" style="margin-top: 20px">
                            <div class="col-xs-4">
                                <rounded-box title="Valor Conta"
                                             :height="'5rem'"
                                             :value="'R$ ' + toMoeda(contaTotal)"></rounded-box>
                            </div>
                            <div class="col-xs-4">
                                <rounded-box title="Consumo"
                                             :height="'5rem'"
                                             :value="toMoeda(consumoTotal) + ' kWh'"></rounded-box>
                            </div>
                            <div class="col-xs-4">
                                <rounded-box title="Valor Tarifa"
                                             :height="'5rem'"
                                             :value="toMoeda(tarifa) + ' R$/kWh'"></rounded-box>
                            </div>
                        </div>

                        <div class="row" style="margin-top: 20px">
                            <div class="col-xs-4">
                                <rounded-box title="Área mínima ocupada"
                                             :height="'5rem'"
                                             :value="
                    toMoeda(parseFloat(caracteristicasBasicas.area)) + ' m²'
                  "></rounded-box>
                            </div>
                            <div class="col-xs-4">
                                <rounded-box title="Peso"
                                             :height="'5rem'"
                                             :value="toMoeda(caracteristicasBasicas.weight) + ' kg'"></rounded-box>
                            </div>
                            <div class="col-xs-4">
                                <rounded-box title="Potência Instalada"
                                             :height="'5rem'"
                                             :value="toMoeda(potenciaGerador) + ' kWp'"></rounded-box>
                            </div>
                        </div>

                        <div class="row" style="margin-top: 20px">

                            <div class="col-xs-4">
                                <rounded-box title="Produção Mensal"
                                             :height="'5rem'"
                                             :value="toMoeda(producaoMensal) + ' kWh'"></rounded-box>
                            </div>
                            <div class="col-xs-4">
                                <rounded-box title="Produção Anual"
                                             :height="'5rem'"
                                             :value="toMoeda(producaoAnual) + ' kWh'"></rounded-box>
                            </div>
                            <div class="col-xs-4">
                                <rounded-box title="Economia Anual"
                                             :height="'5rem'"
                                             :value="'R$ ' + toMoeda(economiaAnual)"></rounded-box>
                            </div>
                        </div>

                    </div>

                    <div class="container" style="margin-top: 25px">
                        <div class="row">
                            <h2 class="header-title">
                                Composição do gerador de energia fotovoltaico
                            </h2>
                        </div>

                        <table class="table"
                               style="border-collapse: separate; border-spacing: 0 1em">
                            <thead style="color: #0083ca !important">
                                <tr>
                                    <th style="
                      border-bottom: 0px;
                      width: 3cm;
                      padding: 4mm;
                      text-align: right;
                    ">
                                        Código
                                    </th>
                                    <th style="border-bottom: 0px; padding: 4mm">Descrição</th>
                                    <th style="
                      border-bottom: 0px;
                      width: 2cm;
                      padding: 4mm;
                      text-align: right;
                    ">
                                        Qtd
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in components"
                                    v-bind:key="item.index"
                                    style="background-color: #f9f9f9 !important; height: 55px">
                                    <td style="
                      vertical-align: top;
                      text-align: right;
                      border-top: 0px;
                      padding: 4mm;
                    ">
                                        {{ item.prdCodigo }}
                                    </td>
                                    <td style="vertical-align: top; border-top: 0px; padding: 4mm">
                                        {{ item.descricao }}
                                    </td>
                                    <td style="
                      vertical-align: top;
                      text-align: right;
                      border-top: 0px;
                      padding: 4mm;
                    ">
                                        {{ item.quantidade }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- ------------------------------------------------------------------------------- -->

                <div ref="content_4" id="content_4" class="pagebreak pageA4">
                    <div class="container">
                        <div class="row" style="margin: 0">
                            <h2 class="header-title">Instalação</h2>
                        </div>
                        <div class="row" style="margin: 0">
                            <p class="label-t mt-3">{{ projeto.informacoesInstalacao }}</p>
                        </div>

                        <div class="layout row wrap" style="margin: 8px 0px 0px 0px">
                            <h2 class="header-title">Condições comerciais</h2>
                        </div>

                        <div class="row mt-3">
                            <div class="col-lg-6 col-sm-6 col-sm-6 col-xs-6">
                                <p class="label-t2 font-weight-bold">Modo de pagamento</p>
                                <p class="label-t4">
                                    {{ modoPagamentos[projeto.modoPagamento] }}
                                </p>

                                <p class="label-t2 font-weight-bold">Prazo de entrega</p>
                                <p class="label-t4">{{ projeto.prazoEntrega }} dias</p>
                            </div>
                            <div v-if="temQtdeParcela"
                                 class="col-lg-6 col-sm-6 col-sm-6 col-xs-6">
                                <p class="label-t2 font-weight-bold">Parcela</p>
                                <p class="label-t4">
                                    {{projeto.cliente.parcelaSelecionada.quantidade}}x
                                    {{ projeto.cliente.parcelaSelecionada.valor | reais}}
                                </p>
                            </div>

                            <div class="col-lg-6 col-sm-6 col-sm-6 col-xs-6">
                                <p class="label-t2 font-weight-bold">Total</p>
                                <p class="label-t4">
                                    {{ investimentoTotal | reais }}
                                </p>
                            </div>

                            <div class="col-xs-12">
                                <p class="label-t2 font-weight-bold">Observações</p>
                                <p class="label-t">{{ projeto.observacoes }}</p>
                            </div>
                        </div>

                        <div class="row">
                            <h2>Data da proposta: {{projeto.criadoEm | formatDate}}</h2>
                        </div>

                        <div class="container" v-if="temRevenda" style="margin-top:30mm">

                            <div class="row">
                                <figure>
                                    <img :src="projeto.contatoRevenda.imagemBase64"
                                         v-if="projeto.contatoRevenda.imagemBase64"
                                         style="max-height: 64px; margin-top: 2mm" />
                                    <img :src="projeto.imagemUrl"
                                         v-if="projeto.imagemUrl"
                                         style="max-height: 64px; margin-top: 2mm" />
                                </figure>
                            </div>

                            <div class="row">
                                <p class="label-t">Nome</p>
                                <p class="label-t bold"
                                   style="padding-left: 4px !important">
                                    {{ projeto.contatoRevenda.nome }}
                                </p>
                            </div>
                            <div class="row">
                                <p class="label-t">Telefone 1</p>
                                <p class="label-t bold"
                                   style="padding-left: 4px !important">
                                    {{ projeto.contatoRevenda.telefone }}
                                </p>
                            </div>

                            <div class="row" style="margin-top: 8px !important">
                                <p class="label-t">E-mail</p>
                                <p class="label-t bold"
                                   style="padding-left: 4px !important">
                                    {{ projeto.contatoRevenda.email }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </v-content>
        </v-app>
    </div>
</template>


<script>
    import "../../../components/partials/santander/SantanderFilter.js";
    import RoundedBox from "./RoundedBox.vue";
    import { mapGetters } from "vuex";
    export default {
        name: "TemplatePdfProject",
        components: {
            RoundedBox,
        },
        watch: {
            "selectedProduct.PRD_DESCR1": function () {
                this.createBaseSimulacao();
            },
        },
        filters: {
            formatDate(value) {
                if (value) {
                    const date = new Date(value);
                    const day = date.getDate().toString().padStart(2, '0');
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}/${month}/${year}`;
                }
            },
        },
        methods: {
            toMoeda(value, decimals = 2) {
                if (isNaN(Number(value))) return value;

                if (!value && value !== 0) {
                    return "";
                }

                const val = (value / 1).toFixed(decimals).replace(".", ",");
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            },
            getGeneratorImage(imgsrc) {
                return "/assets/images/calculadora-solar/" + imgsrc;
            },
            createBaseSimulacao() {
                //<h5>#IMPORTANTE#***SIMULAÇÃO*** baseada no índice de incidência de irradiação Solar da regiões do Brasil por m² #IMPORTANTE#</h5>\r\n<img src=https://download.aldo.com.br/energy/tabela-1-13.jpg border=0>\r\n\r\n<h5>#MATERIAPRIMA#</h5>

                this.textoBaseSimulacao = "";
                this.imagemBaseSimulacao = "";

                let desc =
                    this.selectedProduct.PRD_DESCR1 +
                    this.selectedProduct.PRD_DESCR2 +
                    this.selectedProduct.PRD_DESCR3 +
                    this.selectedProduct.PRD_DESCR4 +
                    this.selectedProduct.PRD_DESCR5 +
                    this.selectedProduct.PRD_DESCR5;

                let descLen = desc.length;
                let indexSimulacao = desc.indexOf("***SIMULAÇÃO***");

                if (indexSimulacao < 0) return "";

                desc = desc.substring(indexSimulacao, descLen);
                descLen = desc.length;

                let indexMATERIAPRIMA = desc.indexOf("#MATERIAPRIMA#");
                if (indexMATERIAPRIMA < 0) return "";

                desc = desc.substring(0, indexMATERIAPRIMA);
                desc = desc.replace(/\\n/g, " ");
                desc = desc.replace(/\\r/g, " ");
                desc = desc.replace(/<h5>/g, "");
                desc = desc.replace(/<\/h5>/g, "").trim();

                let descVet = desc.split("#IMPORTANTE#");

                let img = descVet[1].substring(
                    descVet[1].indexOf("=") + 1,
                    descVet[1].length
                );
                img = img.substring(0, img.indexOf(" "));
                this.textoBaseSimulacao = descVet[0];
                this.imagemBaseSimulacao = img;
            },

            createPDFSendMail(keyProject) {
                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        // swal({
                        //     title: "Email encaminhado com sucesso",
                        //     icon: "success"
                        // })
                    }
                };
                xhr.open("POST", this.$apiUrl + "CalculadoraSolar.svc/sendMailProposta");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(
                    JSON.stringify({
                        codProjeto: keyProject,
                    })
                );
            },
            createPDF() {
                // Get HTML to print from element
                const prtHtml = document.getElementById("print").innerHTML;

                // Get all stylesheets HTML
                let stylesHtml = "";
                for (const node of [
                    ...document.querySelectorAll('link[rel="stylesheet"], style'),
                ]) {
                    stylesHtml += node.outerHTML.replace(
                        "<link ",
                        "<link media='screen,print' "
                    );
                }

                // Open the print window
                const WinPrint = window.open("", "");

                WinPrint.document.write(`<!DOCTYPE html>
        <html>

          <head>
            ${stylesHtml}
          </head>
          <body">

            ${prtHtml}
          </body>
        </html>`);

                WinPrint.document.close();
                WinPrint.focus();

                setTimeout(() => {
                    WinPrint.print();
                    WinPrint.close();
                }, 500);
            },
        },
        computed: {
            ...mapGetters([
                "projeto",
                "caracteristicasBasicas",
                "selectedProduct",
                "components",
                "parcelas",
                "generatorImage",
                "potenciaGerador",
            ]),
            temRevenda() {
                try {
                    return (
                        this.projeto != undefined &&
                        this.projeto.contatoRevenda != undefined &&
                        this.projeto.contatoRevenda.nome != undefined &&
                        this.projeto.contatoRevenda.nome != ""
                    );
                } catch {
                    return false;
                }
            },
            temBaseSimulacao() {
                try {
                    return (
                        this.imagemBaseSimulacao != undefined &&
                        this.imagemBaseSimulacao != ""
                    );
                } catch {
                    return false;
                }
            },
            contaTotal() {
                let valor = 0;
                try {
                    for (let index = 0; index < this.projeto.contas.length; index++) {
                        const element = this.projeto.contas[index];
                        valor +=
                            element.valor
                                .toString()
                                .replace(/\./g, "")
                                .replace(/,/g, ".")
                                .replace(/R\$/g, "")
                                .trim() * 1;
                    }
                    return valor;
                } catch (error) {
                    return 0;
                }
            },

            consumoTotal() {
                let valor = 0;
                try {
                    for (let index = 0; index < this.projeto.contas.length; index++) {
                        const element = this.projeto.contas[index];
                        valor +=
                            element.consumoMensal
                                .toString()
                                .replace(/\./g, "")
                                .replace(/,/g, ".")
                                .replace(/R\$/g, "")
                                .trim() * 1;
                    }
                    return valor;
                } catch (error) {
                    return 0;
                }
            },

            tarifa() {
                let valor = 0;
                try {
                    if (this.projeto.contas.length == 1)
                        return (
                            this.projeto.contas[0].consumoKwh
                                .toString()
                                .replace(/\./g, "")
                                .replace(/,/g, ".")
                                .replace(/R\$/g, "")
                                .trim() * 1
                        );

                    return this.tarifaMedia;
                } catch (error) {
                    return 0;
                }
            },

            tarifaMedia() {
                try {
                    if (this.consumoTotal == 0) return 0;
                    return (this.contaTotal / this.consumoTotal).toFixed(2);
                } catch (error) {
                    return 0;
                }
            },

            economiaAnual() {
                try {
                    return this.contaTotal * 12;
                } catch {
                    return 0;
                }
            },
            retornoInvestimento() {
                try {
                    return Math.round(this.investimentoTotal / this.contaTotal / 12);
                } catch {
                    return 0;
                }
            },
            producaoAnual() {
                try {
                    return this.producaoMensal * 12;
                } catch {
                    return 0;
                }
            },
            producaoMensal() {
                try {
                    return parseFloat(this.potenciaGerador).toFixed(2) * 4.4 * 30;
                } catch {
                    return 0;
                }
            },
            temQtdeParcela() {
                try {
                    return (                  
                        this.projeto.modoPagamento != 0
                    );
                } catch {
                    return false;
                }
            },
            investimentoTotal() {
                try {
                    let qtde = 1;
                    let value =
                        this.projeto.valorEUP
                            .replace(/\./g, "")
                            .replace(/,/g, ".")
                            .replace(/R\$/g, "")
                            .trim() * 1;

                    if (this.temQtdeParcela) {
                        qtde = this.projeto.cliente.parcelaSelecionada.quantidade * 1;
                        value = this.projeto.cliente.parcelaSelecionada.valor;
                    }

                    //console.log(
                    //    this.projeto.valorEUP +
                    //    " - " +
                    //    qtde.toString() +
                    //    "x " +
                    //    "valor ...." +
                    //    value.toString()
                    //);

                    return value * qtde;
                } catch {
                    return 0;
                }
            },
            getImagemProduto() {
                try {
                    return this.selectedProduct.Imagens[0].ArqUrlHires;
                } catch (error) {
                    return "";
                }
            },
        },
        data() {
            return {
                textoBaseSimulacao: "",
                imagemBaseSimulacao: "",
                modoPagamentos: ["À vista", "Financiamento Sol Agora", "Cartão de crédito"],
                aldoSolarLogo: require("./../../../../public/assets/images/calculadora-solar/logo-aldo-solar.svg"),
                thunderImage: require("./../icons/thunder.svg"),
                areaImage: require("./../icons/area.svg"),
                weightImage: require("./../icons/weight.svg"),
                checkImage: require("./../icons/check-icon.svg"),
                userImage: require("./../icons/user.svg"),
                suitcaseImage: require("./../icons/suitcase.svg"),
                infoImage: require("./../icons/info.svg"),
                // headers: [
                //   { text: 'Codigo', align: 'left', value: 'codigo'},
                //   { text: 'Descrição', value: 'description' },
                //   { text: 'Qtd', value: 'qtd' },
                // ],
            };
        },
    };
</script>